import React, { useState } from "react";
import { BASE_URL } from "../utils/config";
import {  useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";

import Stack from "@mui/material/Stack";
import Loading from "../components/loading";


const LevelRecord = ({RecordData, heading, updaterecord ,Email}) => {
   const navigate = useNavigate();  
  const columns = [
        { id: "Action", label: "Action", minWidth: 70 },
        { id: "S.No", label: "S.No", minWidth: 40 },
        { id: "stock_symbol", label: "Stock Symbol", minWidth: 110 },    
        { id: "pivot_point", label: "Pivot Point", minWidth: 100 },
        { id: "r_one", label: "R ONE", minWidth: 120 },
        { id: "r_two", label: "R TWO", minWidth: 90 },
        { id: "r_three", label: "R THREE", minWidth: 80 },
        { id: "s_one", label: "S ONE", minWidth: 90 },
        { id: "s_two", label: "S TWO", minWidth: 110 },
        { id: "s_three", label: "S Three", minWidth: 110 },
    ];

  const [Record, setRecord] = useState([]);
  const [AddDialog, setAddDialog] = useState(false);
  const [RoneError, setRoneError] = useState(false);
  const [RtwoError, setRtwoError] = useState(false);
  const [RthreeError, setRthreeError] = useState(false);
  const [pivotPointError, setPivotPointError] = useState(false);
  const [SoneError, setSoneError] = useState(false);
  const [StwoError, setStwoError] = useState(false);
  const [SthreeError, setSthreeError] = useState(false);
  const [levelStateData, setLevelStateData] = useState({})
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(25);
  const [filters, setFilters] = useState();
  const [filteredRecord, setfilteredRecord] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);

  const [successDialog,setSuccessDialog]=useState(false);
  const [errorDialog,setErrorDialog]=useState(false);
  const [errorMessage,setErrorMessage]=useState("");
  const [successMessage,setSuccessMessage]=useState("");
  const [removeDialog,setRemoveDialog]=useState(false);
  const [clearDialog,setClearDialog]=useState(false);
  const [removeItem,setRemoveItem]=useState();
 




//  handle page change for pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    let startindex = newPage * rowsPerPage;
    console.log("startindex", startindex);
    let endindex = Math.min(startindex + rowsPerPage, Record.length);
    console.log("endindex", endindex);
    setStartIndex(startindex);
    setEndIndex(endindex);
  };

  // handle row change in page
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setEndIndex(+event.target.value);
    setStartIndex(0);
    setPage(0);
  };




//  left tool bar to show button

  const leftToolbarTemplate = () => {
    return (
      <>
        <span className="p-input-icon-left table-search">
          <i className="pi pi-search" />
          <InputText
            type="search"
            value={filters}
            onChange={handleSearch}
            placeholder="Search..."
          />
        </span>
      </>
    );
  };

  // right toolbar to show buttons
  const rightToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2 table-prehead-right">
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            
            onClick={()=>{ClearLevelData('Indices')}}
          >
            Clear Indices
          </Button>

          <Button
            variant="contained"
            onClick={()=>{ClearLevelData('Commodity')}}
          >
            Clear Commodity
          </Button>

          <Button
            variant="contained"
            onClick={()=>{ClearLevelData('Stock')}}
          >
            Clear Stock
          </Button>
        </Stack>
      </div>
    );
  };

//  cleat level data dialog open
  const ClearLevelData = async (value) =>{
    setSelectedItems(value)
    setClearDialog(true);
  }






//  to handle search record

  const handleSearch = (event) => {
    let filetertext = event.target.value;
    setFilters(event.target.value);
    setPage(0);
    setfilteredRecord(
      Record.filter((row) =>
        Object.values(row).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(filetertext.toLowerCase())
        )
      )
    );
  };

 

// to handle clear record data for particular row
  const ClearStockLevelData = async() => {
    setLoading(true)
    const details = JSON.parse(localStorage.getItem('loginData'));
   let body =   JSON.stringify({
      modifiedBy: details.user_id
    })

    await fetch(`${BASE_URL}/clearlevel/${selectedItems}`, {
      method: 'put',
      body: body,
      headers: {
        "Content-Type": "application/json",
         'Authorization': `Bearer ${details.token}`
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        console.log("Level Response ===================res ", res);

        if (res.success === true) {
          setLoading(false)
          setClearDialog(false)
          
          setSuccessMessage('Level Record Successfully Clear.')
         setSuccessDialog(true)
         updaterecord()
         setTimeout(()=>{
         
          setSuccessDialog(false)
          setSuccessMessage('')

         },2000)
        }else if(res.status === 403){ 
          setErrorMessage('Token Invalid or Expire, Please Login Again.')
          setErrorDialog(true)
          setTimeout(()=>{
            setErrorDialog(false)
            setErrorMessage('')
            localStorage.clear()
            navigate('/login')
          },2000)
        }
        else if(res.status === 401){
        
          setErrorMessage('Token Invalid or Expire, Please Login Again.')
          setErrorDialog(true)
          setTimeout(()=>{
            setErrorDialog(false)
            setErrorMessage('')
            localStorage.clear()
            navigate('/login')
          },2000)
        }else{
        setLoading(false)
        setClearDialog(false)
          setErrorMessage(`Error: ${res.message}`)
        setErrorDialog(true)
        setTimeout(()=>{
          setErrorDialog(false)
          setErrorMessage('')
        },2000)
        }
      })
      .catch(error => {
       console.error('Error fetching data:', error);
       setLoading(false)
       setClearDialog(false)
       setErrorMessage(`Error: ${error.message}`)
       setErrorDialog(true)
       setTimeout(()=>{
         setErrorDialog(false)
         setErrorMessage('')
       })
      });
  };
  
  //  hide dialog box for clear all
  const hideClearDialog = () => {
    setClearDialog(false);
  };


 
//  hide dialog box for remove row
  const hideRemoveDialog = () => {
    setRemoveDialog(false);
  };

//  handle input change in value
  const handleInputChange = (event) => {
    console.log("level",levelStateData)
       const { name, value } = event.target;
       if (/^\d*\.?\d{0,2}$/.test(value)) {
         setLevelStateData((prevState) => ({
               ...prevState,
               [name]: value,
         }));
       }else {
          switch (name) {
           case 'r_one':
             setRoneError(true);
             setTimeout(() => setRoneError(false), 2000);
             break;
           case 'r_two':
             setRtwoError(true);
             setTimeout(() => setRtwoError(false), 2000);
             break;
           case 'r_three':
             setRthreeError(true);
             setTimeout(() => setRthreeError(false), 2000);
             break;
           case 'pivot_point':
             setPivotPointError(true);
             setTimeout(() => setPivotPointError(false), 2000);
             break;
           case 's_one':
             setSoneError(true);
             setTimeout(() => setSoneError(false), 2000);
             break;
           case 's_two':
             setStwoError(true);
             setTimeout(() => setStwoError(false), 2000);
             break;
           case 's_three':
             setSthreeError(true);
             setTimeout(() => setSthreeError(false), 2000);
             break;
           default:
             break;
         }
       }
      
   
  };
  
  // handle edit dialog box to show
  const EditRecord = async(row) =>{
   setLevelStateData(row)
   setAddDialog(true)
  }

//  hanlde api call to update the record
  const handleUpdate = async () => {
    console.log("inside form submit")
    setLoading(true)
    const details = JSON.parse(localStorage.getItem('loginData'));
   let body =   JSON.stringify({
      levelData: levelStateData,
      modifiedBy: details.user_id
    })

    console.log("inside form submit",body)
    await fetch(`${BASE_URL}/updatelevel/${levelStateData.id}`, {
      method: 'PUT',
      body: body,
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${details.token}`
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        console.log("Level Response ===================res ", res);

        if (res.success === true) {
          setLoading(false)
          setAddDialog(false)
          
          setSuccessMessage('Level Record Successfully created.')
         setSuccessDialog(true)
         updaterecord()
         setTimeout(()=>{
         
          setSuccessDialog(false)
          setSuccessMessage('')

         },2000)
        }else if(res.status === 403){ 
          setErrorMessage(`Error: ${res.message}`)
          setErrorDialog(true)
          setTimeout(()=>{
            setErrorDialog(false)
            setErrorMessage('')
            localStorage.clear()
               navigate('/login')
          },2000) 
        }
        else if(res.status === 401){
         
          setErrorMessage(`Error: ${res.message}`)
        setErrorDialog(true)
        setTimeout(()=>{
          setErrorDialog(false)
          setErrorMessage('')
          localStorage.clear()
             navigate('/login')
        },2000)
        }else{
        setLoading(false)
         
          setErrorMessage(`Error: ${res.message}`)
        setErrorDialog(true)
        setTimeout(()=>{
          setErrorDialog(false)
          setErrorMessage('')
        },2000)
        }
      })
      .catch(error => {
       console.error('Error fetching data:', error);
       setLoading(false)
       setErrorMessage(`Error: ${error.message}`)
       setErrorDialog(true)
       setTimeout(()=>{
         setErrorDialog(false)
         setErrorMessage('')
       },2000)
      });
  }

  //  handle dialog box to delete the record
  const DeleteRecord = async (row) =>{
    console.log("deleted")
    setRemoveItem(row)
    setRemoveDialog(true);
  }

  // handle api to delete the record 
  const RemoveStock = async ()=>{
    console.log("remove record",removeItem)
    setLoading(true)
    const loginuser = JSON.parse(localStorage.getItem('loginData'));
    await fetch(`${BASE_URL}/deletedlevel/${removeItem.id}`, {
      method: 'delete',
      headers: {
        'Authorization': `Bearer ${loginuser.token}`
      }
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        console.log("Level Response ===================res ", res);

        if (res.success === true) {
          setLoading(false)
          setRemoveDialog(false);
          
          setSuccessMessage('Level Record Successfully Deleted.')
         setSuccessDialog(true)
         updaterecord()
         setTimeout(()=>{
         
          setSuccessDialog(false)
          setSuccessMessage('')

         },2000)
        }else if(res.status === 403){ 
          setErrorMessage(`Error: ${res.message}`)
          setErrorDialog(true)
          setTimeout(()=>{
            setErrorDialog(false)
            setErrorMessage('')
            localStorage.clear()
            navigate('/login')
          },2000)
        }
        else if(res.status === 401){
          
          setErrorMessage(`Error: ${res.message}`)
          setErrorDialog(true)
          setTimeout(()=>{
            setErrorDialog(false)
            setErrorMessage('')
            localStorage.clear()
            navigate('/login')
          },2000)
        }else{
        setLoading(false)
        setRemoveDialog(false);
        setErrorMessage(`Error: ${res.message}`)
        setErrorDialog(true)
        setTimeout(()=>{
          setErrorDialog(false)
          setErrorMessage('')
        },2000)
        }
      })
      .catch(error => {
       console.error('Error fetching data:', error);
       setLoading(false)
       setRemoveDialog(false);
       setErrorMessage(`Error: ${error.message}`)
       setErrorDialog(true)
       setTimeout(()=>{
         setErrorDialog(false)
         setErrorMessage('')
       },2000)
      });

  }

  return (
    <>
      <Sidebar />
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}
        >
          <Loading />
        </div>
      ) : (
        <div >
       
            <div className="container-fluid">
             
              <Toolbar
                className="table-pre-head"
                start={leftToolbarTemplate}
              
                end={Email === 'kamal.joshi@eleservsoft.com' ? rightToolbarTemplate : null}
                // center={centerToolbarTemplate}
              ></Toolbar>
              <div className="table">
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer sx={{ maxHeight: 350 }}>
                    <Table
                      style={{ margin: 0 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          {columns.map((column, index) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              title={
                                column.id === "last_quantity"
                                  ? "Last Quantity"
                                  : column.id === "buy_quantity"
                                  ? "Buy Quantity"
                                  : column.id === "sell_quantity"
                                  ? "Sell Quantity"
                                  : column.id === "lower_circuit_limit"
                                  ? "Lower Circuit Limit"
                                  : column.id === "upper_circuit_limit"
                                  ? "Upper Circuit Limit"
                                  : ""
                              }
                              style={{
                                textAlign: "center",
                                minWidth: column.minWidth,
                                backgroundColor: "#23499E",
                                color: "white",
                                zIndex:
                                  column.id === "S.No" ||
                                  column.id === "Stock_name" ||
                                  column.id === "Action"
                                    ? 20
                                    : 5,
                                left:
                                  column.id === "S.No"
                                    ? 98
                                    : column.id === "Stock_name"
                                    ? 150
                                    : column.id === "Action"
                                    ? 0
                                    : undefined,
                              }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {RecordData.length > 0 ? (
                        <TableBody>
                          {RecordData
                            .slice(startIndex, endIndex)
                            .map((row, index) => {
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={row.code}
                                >
                                  {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                      <TableCell
                                        style={{
                                          position: "sticky",
                                          backgroundColor:"#fff",
                                          zIndex:
                                            column.id === "S.No" ||
                                            column.id === "Stock_name" ||
                                            column.id === "Action"
                                              ? 10
                                              : 1,
                                          left:
                                            column.id === "S.No"
                                              ? 98
                                              : column.id === "Stock_name"
                                              ? 150
                                              : column.id === "Action"
                                              ? 0
                                              : undefined,
                                        }}
                                        class="table-cell-screenerTab"
                                        key={column.id}
                                        align={column.align}
                                      >
                                        {column.id === "S.No" ? (
                                          index + 1
                                        ) : column.id === "Action" ? (
                                          <div className="actions">
                                            <span>
                                            <i
                                              className="pi pi-trash"
                                              style={{
                                                color: "#23499E",
                                                cursor: "pointer",
                                                marginRight: "10px",
                                              }}
                                              title="Add In Script Record"
                                              onClick={() =>
                                                DeleteRecord(row)
                                              }
                                            ></i>
                                            </span> 
                                            <span>
                                            <i
                                              className="pi pi-pencil"
                                              style={{
                                                color: "#23499E",
                                                cursor: "pointer",
                                                marginRight: "10px",
                                              }}
                                              title="Add In Script Record"
                                              onClick={() =>
                                                EditRecord(row)
                                              }
                                            ></i>
                                            </span>
                                          </div>
                                        ) : (
                                          value
                                        )}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      ) : null}
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[25, 50, 75, 100]}
                    component="div"
                    count={filteredRecord.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </div>
            </div>
         


          {/*Error Message Dialog */}
          <Dialog
      open={errorDialog}
      onClose={()=>{setErrorDialog(false)}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle  id="alert-dialog-title">
      <h4 style={{ color: "red" }}>Failure</h4>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         
               
          {errorMessage}
           
        
        </DialogContentText>
      </DialogContent>
     
          </Dialog>

           {/*Success Message Dialog */}
           <Dialog
      open={successDialog}
      onClose={()=>{setSuccessDialog(false)}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle  id="alert-dialog-title">
      <h4 style={{ color: "green"}}>Success</h4>
       
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         
             
               <span style={{ color: "black" }}>
                  {successMessage}
                </span>
              
 
        </DialogContentText>
      </DialogContent>
     
           </Dialog>


         {/*Remove all  dialog */}
          <Dialog
            open={removeDialog}
            onClose={hideRemoveDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
              {"Confirm Remove"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                
                  <span style={{ color: "black" }}>
                    Are you sure, you want to Remove This Stock From Level. 
                  </span>
             
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={hideRemoveDialog}
              >
                No
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={RemoveStock}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

{/*  to confirm clear selected record */}
          <Dialog
            open={clearDialog}
            onClose={hideClearDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
              {"Confirm Clear Data"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                
                  <span style={{ color: "black" }}>
                    {`Are you sure, you want to Clear ${selectedItems} Level.`} 
                  </span>
             
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={hideClearDialog}
              >
                No
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={ClearStockLevelData}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

          {/* edit Dialog */}

          <Dialog
      open={AddDialog}
      onClose={() => setAddDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md" // Setting maxWidth to 'md' (medium size)
      fullWidth // Ensuring the dialog takes the full width allowed by maxWidth
      PaperProps={{
        style: {
          width: '60%',
          height: '80vh',
          margin: 'auto', // Center the dialog
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <h4 style={{ color: 'black' }}>Edit Level Record</h4>
      </DialogTitle>
      <DialogContent>
        <div>
          {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
           
          </div> */}

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
          <div style={{ width: '48%' }}>
              <p>Stock Symbol:<span className='asterisk'>*</span></p>
              {/* <ReactSelect
                id="stock_symbol"
                name="stock_symbol"
                options={options}
                onChange={handlechangestock}
                styles={customStyles}
              /> */}
               <input
                value={levelStateData.stock_symbol}
                type="text"
                id="stock_symbol"
                name="stock_symbol"
                // onChange={handleInputChange}
                style={{width: '256px'}}
                disabled="ture"
              />
            </div>


            <div style={{ width: '48%' }}>
              <p>Stock Type:<span className='asterisk'>*</span></p>
            
              <input
                value={levelStateData.StockType}
                type="text"
                id="StockType"
                name="StockType"
                // onChange={handleInputChange}
                style={{width: '256px'}}
                disabled="ture"
              />
            </div>


            <div style={{ width: '48%' }}>
              <p>R-ONE:</p>
              <input
                value={levelStateData.r_one}
                type="number"
                id="r_one"
                name="r_one"
                onChange={handleInputChange}
                style={{width: '256px'}}
              />
              {RoneError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>R-Two:</p>
              <input
                value={levelStateData.r_two}
                type="number"
                id="r_two"
                name="r_two"
                onChange={handleInputChange}
                style={{width: '256px'}}
              />
              {RtwoError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>R-Three:</p>
              <input
                value={levelStateData.r_three}
                type="number"
                id="r_three"
                name="r_three"
                style={{width: '256px'}}
                onChange={handleInputChange}
              />
              {RthreeError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>Pivot Point:</p>
              <input
                value={levelStateData.pivot_point}
                type="number"
                id="pivot_point"
                name="pivot_point"
                style={{width: '256px'}}
                onChange={handleInputChange}
              />
              {pivotPointError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>S-One:</p>
              <input
                value={levelStateData.s_one}
                type="number"
                id="s_one"
                name="s_one"
                style={{width: '256px'}}
                onChange={handleInputChange}
              />
              {SoneError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>S-Two:</p>
              <input
                value={levelStateData.s_two}
                type="number"
                id="s_two"
                name="s_two"
                style={{width: '256px'}}
                onChange={handleInputChange}
              />
              {StwoError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>S-Three:</p>
              <input
                value={levelStateData.s_three}
                type="number"
                id="s_three"
                name="s_three"
                style={{width: '256px'}}
                onChange={handleInputChange}
              />
              {SthreeError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions style={{display:'flex', justifyContent: 'flex-end' }}>
        <Button style={{color:'white',backgroundColor:'#23499E'}} onClick={() => setAddDialog(false)} >
          Cancel
        </Button>
        <Button onClick={handleUpdate}style={{color:'white',backgroundColor:'#23499E'}}>
          Update
        </Button>
      </DialogActions>
          </Dialog>

      
        </div>
      )}
    </>
  );
};

export default LevelRecord;

